import { render, staticRenderFns } from "./AboutYou.vue?vue&type=template&id=0994e8a3&"
import script from "./AboutYou.vue?vue&type=script&lang=js&"
export * from "./AboutYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports